import { FormSection } from '@/containers/forms/FormSection'
import { ParametersForm } from '../forms/ParametersForm'
import type { BaseContainerProps } from '.'

export const Parameters = (props: BaseContainerProps) => {
  return (
    <FormSection {...props}>
      <ParametersForm />
    </FormSection>
  )
}